export function formatFoodQuantity(value, maximumFractionDigits = 2) {
  if (value === null || value === undefined || value === '') return '';
  const number = Number(value);
  if (!Number.isFinite(number)) return String(value);
  return Number(number.toFixed(maximumFractionDigits)).toString();
}

export function roundFoodQuantity(value, maximumFractionDigits = 4) {
  if (value === null || value === undefined || value === '') return value;
  const number = Number(value);
  return Number.isFinite(number) ? Number(number.toFixed(maximumFractionDigits)) : value;
}

export function buildFoodServingHint(food = {}) {
  const servingWeight = parseFloat(food.serving_weight) || null;
  const servingVolume = parseFloat(food.serving_volume) || null;
  const parts = [];

  if (food.serving_description) parts.push(food.serving_description);
  if (servingWeight) parts.push(`${formatFoodQuantity(servingWeight)}g`);
  if (servingVolume) parts.push(`${formatFoodQuantity(servingVolume)}ml`);

  if (parts.length === 0) {
    const servingSize = parseFloat(food.serving_size) || null;
    const servingUnit = food.serving_quantity_unit || food.serving_unit;
    if (servingSize && servingUnit) {
      parts.push(`${formatFoodQuantity(servingSize)}${servingUnit}`);
    }
  }

  return parts.length > 0 ? `1 serving = ${parts.join(' / ')}` : null;
}
